export default class PostResetTime {
    constructor() {
        const elements = document.querySelectorAll(".js-reset-second");

        if (elements.length > 0) {
            import(
                /* webpackChunkName: "Header" */ "../classes/PostResetTime"
            ).then(res => {
                const PostResetTime = res.default;
                this.createInstance(PostResetTime, elements);
            });
        }
    }

    createInstance(PostResetTime, elements) {
        return new PostResetTime(elements);
    }
}
